
<div class="container-fluid  ">
  <div class="row">
    <div class="col-md-6 colors">
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px;">
        Technologies</h3>

          <h3><span class="badge badge-secondary">HTML5</span> </h3>
          <h3><span class="badge badge-info">HTML5</span></h3>
          <h3><span class="badge badge-secondary">HTML5</span></h3>
          <h3><span class="badge badge-danger">HTML5</span></h3>
          <h3><span class="badge badge-secondary">HTML5</span></h3>
          <h3><span class="badge badge-primary">HTML5</span></h3>




    </div>
    <div class="col-md-6 colors2" data-aos="fade-left">
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px;">
        My Skills</h3>
<br>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-11">
          <ul>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
          </ul>
        </div>
      </div>

    </div>
  </div>


  <div class="row">
    <div class="col-md-6 colors1">
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px;">
       Outils</h3>
      <div class="row">
        <div class="col-md-4">
          <h3><span class="badge badge-secondary">HTML5</span> </h3>
          <h3><span class="badge badge-info">HTML5</span></h3>
        </div>
        <div class="col-md-4">
          <h3><span class="badge badge-secondary">HTML5</span></h3>
          <h3><span class="badge badge-danger">HTML5</span></h3>
          <h3><span class="badge badge-secondary">HTML5</span></h3>
        </div>
        <div class="col-md-4">
          <h3><span class="badge badge-primary">HTML5</span></h3>
        </div>
      </div>




    </div>
    <div class="col-md-6 colors" data-aos="fade-left">
      <h3 style="text-align: center;font-family: Tangerine,serif;font-size: 60px">
        Savoir Etre</h3>
      <br>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-11">
          <ul>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
            <li>Lorem Lorem Lorem Lorem Lorem Lorem Lorem </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</div>
